import { sprintf, __ } from '@wordpress/i18n';

import logoMakerDefaultState from './logoMakerDefaultState';

/* eslint-disable import/no-unresolved -- url param is causing the eslint error but it's not an issue */
import watermarkImage from '../static/images/logo-maker/watermark_logo.svg?url';
import raidLogo from '../static/images/logo-maker/raid_logo.svg?url';
import appStoreBadge from '../static/images/app_store_badge_en.svg?url';
import googlePlayBadge from '../static/images/google_play_badge_en.svg?url';
/* eslint-enable import/no-unresolved */

import raidBanner from '../static/images/logo-maker/raid_banner.jpg';
import raidBannerMobile from '../static/images/logo-maker/raid_banner_mobile.jpg';
import raidPromo from '../static/images/logo-maker/raid_promo.jpg';
import tooltopScreenshotStep1 from '../static/images/logo-maker/tooltip-screenshot-step-1.png';
import tooltopScreenshotStep2 from '../static/images/logo-maker/tooltip-screenshot-step-2.png';

import nicknameGeneratorAvatar1 from '../static/images/nickname-generator/avatar-1.jpg';
import nicknameGeneratorAvatar2 from '../static/images/nickname-generator/avatar-2.jpg';
import nicknameGeneratorAvatar3 from '../static/images/nickname-generator/avatar-3.jpg';
import nicknameGeneratorAvatar4 from '../static/images/nickname-generator/avatar-4.jpg';
import nicknameGeneratorAvatar5 from '../static/images/nickname-generator/avatar-5.jpg';
import nicknameGeneratorAvatar6 from '../static/images/nickname-generator/avatar-6.jpg';
import nicknameGeneratorAvatar7 from '../static/images/nickname-generator/avatar-7.jpg';

/**
 * Get data from WP localized scripts
 */
const { plariumNicknameGenerator, plariumLogoMaker, plariumNicknameGeneratorParams } = window;

// Define the link parameters for the `widget-generator-global-v3` links object
const promoQueryParams = {
  promoGoogleStore: plariumNicknameGeneratorParams?.android || 'pid=SEO&c=1101828',
  promoAppleStore: plariumNicknameGeneratorParams?.ios || 'pid=SEO&c=1101827',
  promoGoogleStoreTop: plariumNicknameGeneratorParams?.android || 'pid=SEO&c=1101828',
  promoAppleStoreTop: plariumNicknameGeneratorParams?.ios || 'pid=SEO&c=1101827',
};

const currentLanguageCode = document.location.pathname.split('/').slice(1, 2).toString();

/**
 * Format the options for the nickname generator dropdown
 */
const nicknameGeneratorDropdownOptions = plariumNicknameGenerator?.generators.map((generator) => ({
  strings: { title: generator.title },
  links: { url: generator.url },
  options: { value: generator.group, compositeId: generator.group },
}));

export const widgetDefaults = {
  'widget-articles-aside-promoted-game-v3': {
    strings: {
      title: __('RAID: Shadow Legends', 'plarium-mini-apps'),
      subtitle: __('Collect 800+ Champions & Fight For Glory', 'plarium-mini-apps'),
      label: __('Play for Free', 'plarium-mini-apps'),
      analyticsGameName: '%gameName%',
    },
    links: {
      url: `https://portal.plarium.com/${currentLanguageCode}/download/?pxl=seo&appid=27&plid=1224462`,
      googlePlayUrl: 'https://app.appsflyer.com/com.plarium.raidlegends?pid=SEO&c=1224461',
      appStoreUrl: 'https://app.appsflyer.com/id1371565796?pid=SEO&c=1224460',
    },
    images: { promoImg: { src: raidPromo, alt: 'promoImg' } },
    options: { authGameTheme: 'default', isRedirectDownload: 'true' },
    repeaters: {},
  },
  'widget-articles-banners-v3': {
    links: {},
    strings: {},
    images: {},
    template_options: {},
    repeaters: {
      banners: [
        {
          links: {
            downloadLink: `https://portal.plarium.com/${currentLanguageCode}/download/?pxl=seo&appid=27&plid=1224462`,
            appStoreLink: 'https://app.appsflyer.com/id1371565796?pid=SEO&c=1224460',
            googlePlayLink: 'https://app.appsflyer.com/com.plarium.raidlegends?pid=SEO&c=1224461',
          },
          strings: {
            slogan: __('ON DESKTOP & MOBILE', 'plarium-mini-apps'),
            buttonText: __('Play for Free', 'plarium-mini-apps'),
          },
          images: {
            mainBg: {
              src: raidBanner,
            },
            mainBgMobile: {
              src: raidBannerMobile,
            },
            mainBgTablet: {
              src: raidBanner,
            },
            logo: {
              src: raidLogo,
            },
          },
          options: {
            bannerId: 'default',
          },
          repeaters: {},
        },
      ],
    },
  },
  'widget-generator-dropdown-active-v3': {
    strings: {},
    links: {},
    images: {},
    options: { activeValue: plariumNicknameGenerator?.activeValue },
    repeaters: {},
  },
  'widget-generator-dropdown-v3': {
    strings: { title: __('What are you looking for?', 'plarium-mini-apps') },
    links: {},
    images: {},
    options: {},
    repeaters: {
      group: nicknameGeneratorDropdownOptions,
    },
  },
  'widget-generator-gender-v3': {
    strings: {},
    links: {},
    images: {},
    options: { defaultRadioButton: '0' },
    repeaters: {
      gender: [
        {
          strings: { title: __('Masculine', 'plarium-mini-apps') },
          links: {},
          images: {},
          options: { value: '0', compositeId: '' },
          repeaters: {},
        },
        {
          strings: { title: __('Feminine', 'plarium-mini-apps') },
          links: {},
          images: {},
          options: { value: '1', compositeId: '' },
          repeaters: {},
        },
        {
          strings: { title: __('Random', 'plarium-mini-apps') },
          links: {},
          images: {},
          options: { value: '2', compositeId: '' },
          repeaters: {},
        },
      ],
    },
  },
  'widget-generator-global-v3': {
    strings: {
      generateButton: __('Generate', 'plarium-mini-apps'),
      copyButton: __('Copy', 'plarium-mini-apps'),
      successCopied: __('Copied', 'plarium-mini-apps'),
      validateError: __('Validation error', 'plarium-mini-apps'),
      getRaidButton: '%get raid button%',
      getRaidPCButton: '%get raid button%',
      playWithButton: __('Play for Free', 'plarium-mini-apps'),
      learnMore: '%Learn more about Raid%',
      promoGameTitle: plariumNicknameGenerator?.promotedGameBanner.title,
      promoGenre: plariumNicknameGenerator?.promotedGameBanner.tagline,
      /* translators: %s is a placeholder for the nickname */
      seoNicknameText: __('Hey, %s!', 'plarium-mini-apps'),
      playGameText: sprintf(
        /* translators: %1$s is a placeholder for URL of the game */
        __(
          'Play <a href="%1$s">RAID: Shadow Legends</a> with your Generated Nickname!',
          'plarium-mini-apps',
        ),
        `${plariumNicknameGenerator?.siteUrl}/game/raid-shadow-legends/`,
      ),
      seoText: __(
        'Wanna take your new nickname into battle in RAID: Shadow Legends?',
        'plarium-mini-apps',
      ),
    },
    links: {
      url: '#link',
      downloadAppCommon: '#downloadAppWin32',
      downloadAppWin32:
        '\u002F\u002Fplarium.com\u002Fservices\u002Fapi\u002Fdownloads\u002Fdesktop?v=1.0.7.0&lid=1&win32',
      downloadAppWin64:
        '\u002F\u002Fplarium.com\u002Fservices\u002Fapi\u002Fdownloads\u002Fdesktop?v=1.0.7.0&lid=1&win64',
      downloadAppOSX:
        '\u002F\u002Fplarium.com\u002Fservices\u002Fapi\u002Fdownloads\u002Fdesktop?v=1.0.7.0&lid=1&mac',
      promoGoogleStore: `https://app.appsflyer.com/com.plarium.raidlegends?${promoQueryParams.promoGoogleStore}`, // Below generator - mobile
      promoAppleStore: `https://app.appsflyer.com/id1371565796?${promoQueryParams.promoAppleStore}`, // Below generator - mobile
      promoGoogleStoreTop: `https://app.appsflyer.com/com.plarium.raidlegends?${promoQueryParams.promoGoogleStoreTop}`, // Below generator - tablet
      promoAppleStoreTop: `https://app.appsflyer.com/id1371565796?${promoQueryParams.promoAppleStoreTop}`, // Below generator - tablet
    },
    images: {
      promoGameIcon: {
        src: plariumNicknameGenerator?.promotedGameBanner?.icon_url,
        alt: 'promoGameIcon',
      },
    },
    options: {},
    repeaters: {
      avatars: [
        {
          strings: {},
          links: {},
          images: { avatar: { src: nicknameGeneratorAvatar1, alt: 'avatar' } },
          options: { compositeId: '1' },
          repeaters: {},
        },
        {
          strings: {},
          links: {},
          images: { avatar: { src: nicknameGeneratorAvatar2, alt: 'avatar' } },
          options: { compositeId: '2' },
          repeaters: {},
        },
        {
          strings: {},
          links: {},
          images: { avatar: { src: nicknameGeneratorAvatar3, alt: 'avatar' } },
          options: { compositeId: '3' },
          repeaters: {},
        },
        {
          strings: {},
          links: {},
          images: { avatar: { src: nicknameGeneratorAvatar4, alt: 'avatar' } },
          options: { compositeId: '4' },
          repeaters: {},
        },
        {
          strings: {},
          links: {},
          images: { avatar: { src: nicknameGeneratorAvatar5, alt: 'avatar' } },
          options: { compositeId: '5' },
          repeaters: {},
        },
        {
          strings: {},
          links: {},
          images: { avatar: { src: nicknameGeneratorAvatar6, alt: 'avatar' } },
          options: { compositeId: '6' },
          repeaters: {},
        },
        {
          strings: {},
          links: {},
          images: { avatar: { src: nicknameGeneratorAvatar7, alt: 'avatar' } },
          options: { compositeId: '7' },
          repeaters: {},
        },
      ],
    },
  },
  'widget-generator-v3': {
    options: { direction: 'column' },
  },
  'widget-global-static-v3': {
    images: {
      appleStoreLogo: {
        src: appStoreBadge,
        alt: 'appleStoreLogo',
      },
      googlePlayLogo: {
        src: googlePlayBadge,
        alt: 'googlePlayLogo',
      },
    },
  },
  'widget-logo-maker-editor-options-v3': {
    strings: {
      validationLength: '20',
      textSizeMin: '0',
      textSizeMax: '100',
      textOpacityMin: '0',
      textOpacityMax: '100',
      textCurveMin: '0',
      textCurveMax: '100',
      textRotationMin: '-180',
      textRotationMax: '180',
      textOffsetXMin: '0',
      textOffsetXMax: '100',
      textOffsetYMin: '0',
      textOffsetYMax: '100',
      textBlurMin: '0',
      textBlurMax: '100',
      textOutlineWidthMin: '0',
      textOutlineWidthMax: '100',
      sloganSizeMin: '0',
      sloganSizeMax: '100',
      sloganOpacityMin: '0',
      sloganOpacityMax: '100',
      sloganCurveMin: '0',
      sloganCurveMax: '100',
      sloganRotationMin: '-180',
      sloganRotationMax: '180',
      sloganOffsetXMin: '0',
      sloganOffsetXMax: '100',
      sloganOffsetYMin: '0',
      sloganOffsetYMax: '100',
      sloganBlurMin: '0',
      sloganBlurMax: '100',
      sloganOutlineWidthMin: '0',
      sloganOutlineWidthMax: '100',
      logoSizeMin: '0',
      logoSizeMax: '100',
      logoOpacityMin: '0',
      logoOpacityMax: '100',
      logoOutlineWidthMin: '0',
      logoOutlineWidthMax: '100',
      shapeSizeMin: '0',
      shapeSizeMax: '100',
      shapeOpacityMin: '0',
      shapeOpacityMax: '100',
      frameSizeMin: '0',
      frameSizeMax: '100',
      frameOpacityMin: '0',
      frameOpacityMax: '100',
      patternOpacityMin: '0',
      patternOpacityMax: '100',
      mainTextDefaultFontSize: '42',
      mainTextDefaultOpacity: '100',
      mainTextDefaultCurvature: '0',
      mainTextDefaultRotation: '0',
      mainTextDefaultShadowX: '0',
      mainTextDefaultShadowY: '0',
      mainTextDefaultShadowBlur: '0',
      mainTextDefaultOutlineStrokeThickness: '0',
      sloganDefaultFontSize: '42',
      sloganDefaultOpacity: '100',
      sloganDefaultCurvature: '0',
      sloganDefaultRotation: '0',
      sloganDefaultShadowX: '0',
      sloganDefaultShadowY: '0',
      sloganDefaultShadowBlur: '0',
      sloganDefaultOutlineStrokeThickness: '0',
      logoDefaultOpacity: '0',
      logoDefaultScale: '25',
      logoDefaultOutlineWidth: '0',
      frameDefaultAlpha: '100',
      frameDefaultScale: '50',
      shapeImageDefaultOpacity: '100',
      shapeImageDefaultScale: '50',
      backgroundDefaultColorOpacity: '100',
      backgroundDefaultPatternOpacity: '100',
    },
    links: {},
    images: {},
    options: {},
    repeaters: {},
  },
  'widget-logo-maker-editor-v3': {
    strings: {
      sloganTextTabLabel: __('Slogan text', 'plarium-mini-apps'),
      gamerNameTabLabel: __('Gamer name', 'plarium-mini-apps'),
      logoIconTabLabel: __('Logo icon', 'plarium-mini-apps'),
      shapeTabLabel: __('Background shape', 'plarium-mini-apps'),
      frameTabLabel: __('Frame', 'plarium-mini-apps'),
      backgroundTabLabel: __('Background', 'plarium-mini-apps'),
      backgroundPatternTabLabel: __('Background pattern', 'plarium-mini-apps'),
      sloganTextLabel: __('Slogan text', 'plarium-mini-apps'),
      gamerTextLabel: __('Gamer name text', 'plarium-mini-apps'),
      fontLabel: __('Font', 'plarium-mini-apps'),
      textColorLabel: __('Text color', 'plarium-mini-apps'),
      sizeLabel: __('Size', 'plarium-mini-apps'),
      opacityLabel: __('Opacity', 'plarium-mini-apps'),
      curveLabel: __('Curvature', 'plarium-mini-apps'),
      frameLabel: __('Select a frame', 'plarium-mini-apps'),
      logoLabel: __('Select an icon', 'plarium-mini-apps'),
      shapeLabel: __('Select a shape', 'plarium-mini-apps'),
      rotationLabel: __('Rotation', 'plarium-mini-apps'),
      shadowLabel: __('Shadow', 'plarium-mini-apps'),
      outlineLabel: __('Outline', 'plarium-mini-apps'),
      shadowColorLabel: __('Shadow color', 'plarium-mini-apps'),
      offsetXLabel: __('Offset X', 'plarium-mini-apps'),
      offsetYLabel: __('Offset Y', 'plarium-mini-apps'),
      blurLabel: __('Blur', 'plarium-mini-apps'),
      outlineWidthLabel: __('Outline width', 'plarium-mini-apps'),
      outlineColorLabel: __('Outline color', 'plarium-mini-apps'),
      selectLogoLabel: '%selectLogoLabel%',
      selectShapeLabel: '%selectShapeLabel%',
      selectFrameLabel: '%selectFrameLabel%',
      selectPatternLabel: '%selectPatternLabel%',
      logoColorLabel: '%logoColorLabel%',
      shapeColorLabel: __('Shape color', 'plarium-mini-apps'),
      frameColorLabel: __('Frame color', 'plarium-mini-apps'),
      patternColorLabel: '%patternColorLabel%',
      canvasColorLabel: __('Canvas color', 'plarium-mini-apps'),
      logoOpacityLabel: __('Opacity', 'plarium-mini-apps'),
      frameOpacityLabel: __('Opacity', 'plarium-mini-apps'),
      shapeOpacityLabel: __('Opacity', 'plarium-mini-apps'),
      patternOpacityLabel: __('Pattern opacity', 'plarium-mini-apps'),
      chooseLogoLabel: __('Select an icon', 'plarium-mini-apps'),
      chooseShapeLabel: __('Select a shape', 'plarium-mini-apps'),
      chooseFrameLabel: __('Select a frame', 'plarium-mini-apps'),
      choosePatternLabel: __('Select a pattern', 'plarium-mini-apps'),
      chooseFontLabel: __('Select a font', 'plarium-mini-apps'),
      chooseColorLabel: __('Choose a color', 'plarium-mini-apps'),
      colorsLabel: __('Colors', 'plarium-mini-apps'),
      paletteLabel: __('Palette', 'plarium-mini-apps'),
      colorFillLabel: __('Color fill', 'plarium-mini-apps'),
      homeLabel: __('Home', 'plarium-mini-apps'),
      downloadLabel: __('Download Logo', 'plarium-mini-apps'),
      defaultResetConfig: JSON.stringify(logoMakerDefaultState),
      textTooltipLabel: __('Logo text', 'plarium-mini-apps'),
      iconTooltipLabel: __('Logo icon', 'plarium-mini-apps'),
      shapeTooltipLabel: __('Background shape', 'plarium-mini-apps'),
      frameTooltipLabel: __('Frame', 'plarium-mini-apps'),
      backgroundTooltipLabel: __('Background', 'plarium-mini-apps'),
      resetTooltipLabel: __('Reset', 'plarium-mini-apps'),
      resetPopupTitle: __(
        'Are you sure you want to reset? All changes will be lost.',
        'plarium-mini-apps',
      ),
      cancelLabel: __('Cancel', 'plarium-mini-apps'),
      resetLabel: __('Reset', 'plarium-mini-apps'),
      undoTooltipLabel: __('Undo', 'plarium-mini-apps'),
      redoTooltipLabel: __('Redo', 'plarium-mini-apps'),
      bannerId: 'default',
    },
    links: {
      homeLink: `${plariumLogoMaker?.siteUrl}/resource/maker/gaming-logo-maker/`,
      thankYouPageLink: `${plariumLogoMaker?.siteUrl}/resource/maker/gaming-logo-maker/thank-you/`,
    },
    images: {
      watermarkImage: {
        src: watermarkImage,
        alt: 'watermarkImage',
      },
    },
    options: { isWatermarkEnabled: 'true' },
    repeaters: {
      tabsColorPicker: [
        {
          strings: { label: __('Colors', 'plarium-mini-apps') },
          links: {},
          images: {},
          options: { value: 'colors', compositeId: 'dev_62' },
          repeaters: {},
        },
        {
          strings: { label: __('Palette', 'plarium-mini-apps') },
          links: {},
          images: {},
          options: { value: 'palette', compositeId: 'dev_63' },
          repeaters: {},
        },
      ],
    },
  },
  'widget-logo-maker-home-content-v3': {
    strings: {
      createLogoButtonText: __('Create Logo', 'plarium-mini-apps'),
      lessButtonText: __('Less', 'plarium-mini-apps'),
      moreButtonText: __('More', 'plarium-mini-apps'),
      gameCreatePlaceholder: __('Gamer Name', 'plarium-mini-apps'),
      sloganPlaceholder: __('Slogan', 'plarium-mini-apps'),
      categoryPlaceholder: __('Theme', 'plarium-mini-apps'),
      gamerNameValidationLength: '10',
      sloganValidationLength: '10',
      gamerNameErrorText: __('Maximum 10 characters', 'plarium-mini-apps'),
      sloganErrorText: __('Maximum 10 characters', 'plarium-mini-apps'),
    },
    links: {},
    images: {},
    options: {},
    repeaters: {
      categoriesSelectOptions: [
        {
          strings: { label: '%label%', value: '%value%' },
          links: {},
          images: {},
          options: { compositeId: 'dev_63' },
          repeaters: {},
        },
      ],
    },
  },
  'widget-logo-maker-home-gallery-v3': {
    strings: {
      countDesktopElements: '8',
      countTabletElements: '8',
      countMobileElements: '8',
      editText: __('Edit', 'plarium-mini-apps'),
      downloadText: __('Download', 'plarium-mini-apps'),
      selectDefaultAllText: __('All', 'plarium-mini-apps'),
    },
    links: {
      redirectEditLogoLink: `${plariumLogoMaker?.siteUrl}/resource/maker/gaming-logo-maker/editor/`,
      thankYouPageLink: `${plariumLogoMaker?.siteUrl}/resource/maker/gaming-logo-maker/thank-you/`,
    },
    images: {
      watermarkImage: {
        src: watermarkImage,
        alt: 'watermarkImage',
      },
    },
    options: { isWatermarkEnabled: 'true', isVisibleEdit: 'true', isShowPixiGallery: 'true' },
    repeaters: {
      gallery: [
        {
          strings: {
            mainImageAltText: '',
            config:
              '{"mainText":{},"sloganText":{},"background":{},"frame":{},"logo":{},"shapeImage":{}}',
            category: '%category%',
          },
          links: {},
          images: { mainImage: { src: '%mainImage%', alt: 'mainImage' } },
          options: { compositeId: 'dev_65' },
          repeaters: {},
        },
      ],
    },
  },
  'widget-logo-maker-thank-you-raid-id-v3': {
    strings: {
      title: __('Get your non-watermarked logo for FREE!', 'plarium-mini-apps'),
      descriptionHTML: __(
        'Download and play RAID: Shadow Legends to get a high-quality version without a watermark!',
        'plarium-mini-apps',
      ),
      firstStep: __('Download and play RAID', 'plarium-mini-apps'),
      freeDownload: __('Free Download', 'plarium-mini-apps'),
      secondStep: __('Enter your Player ID', 'plarium-mini-apps'),
      raidIdPlaceholder: __('Enter your Player ID', 'plarium-mini-apps'),
      thirdStep: __('Get your free logo!', 'plarium-mini-apps'),
      downloadLogo: __('Download Logo', 'plarium-mini-apps'),
      invalidFormatText: __(
        "Check you've typed your Player ID correctly and try again.",
        'plarium-mini-apps',
      ),
      tooltipTitle: __('How to find your Player ID', 'plarium-mini-apps'),
      tooltipDescription: __(
        'Open the game. Select your Avatar in the top-left corner to open your Profile. Then, open the Info tab to find your Player ID.',
        'plarium-mini-apps',
      ),
    },
    links: {
      freeDownloadLink: `https://portal.plarium.com/${currentLanguageCode}/download/?plid=1376675&appId=27`,
      appleStoreUrl: 'https://app.appsflyer.com/id1371565796?plid=SEO&c=1376676',
      googlePlayUrl: 'https://app.appsflyer.com/com.plarium.raidlegends?plid=SEO&c=1376677',
      redirectUrl: `${plariumLogoMaker?.siteUrl}/resource/maker/gaming-logo-maker/`,
    },
    images: {
      tooltipScreenshotStep1: { src: tooltopScreenshotStep1, alt: 'tooltipScreenshotStep1' },
      tooltipScreenshotStep2: { src: tooltopScreenshotStep2, alt: 'tooltipScreenshotStep2' },
    },
    options: {},
    repeaters: {},
  },
};
export default widgetDefaults;
